module.exports = __webpack_public_path__ + "static/img/AUS-shield-logo.9c28082.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AUS-shield-logo.svg
// module id = 3fWG
// module chunks = 1